<nz-header class="site-topbar" [style.background-color]="secondaryColor">
  <nz-row nzAlign="middle" nzJustify="space-between">
    <!-- LEFT SECTION -->
    <nz-col>
      <nz-space nzSize="middle" nzAlign="center">
        <!-- Menu -->
        <span class="header-trigger" (click)="openMenu()">
          <i nz-icon nzType="menu" style="color: #fff"></i>
        </span>

        <!-- Logo -->
        <a class="logo topbar-brand-link" [routerLink]="['/']" (click)="setIsCollapsed(true)">

          <img
            *ngIf="showLogo"
            [src]="logoUrl"
            class="topbar-logo"
            alt="Logo"
          />

          <span
            *ngIf="!showLogo"
            class="topbar-brand">
            {{ brandName }}
          </span>

</a>

        <!-- Create PDA -->
        <a
          *abpPermission="'Transactions.Proformas.Create'"
          nz-button
          nzType="dashed"
          [routerLink]="['/', 'pages', 'proforma', 'create']"
        >
          <i nz-icon nzType="file-search"></i>
          Create PDA
        </a>

        <nz-divider nzType="vertical"></nz-divider>

        <!-- Search -->
        <nz-input-wrapper class="nz-input-search">
          <input
            #search
            nz-input
            placeholder="Search [ctrl+space]"
            [(ngModel)]="searchText"
            (input)="onInput($event)"
            [nzAutocomplete]="auto"
            (focus)="initSearch()"
          />
          <ng-container nzInputSuffix><ng-container *ngTemplateOutlet="suffixIconSearch"></ng-container></ng-container>
        </nz-input-wrapper>

        <ng-template #suffixIconSearch>
          <i nz-icon nzType="search"></i>
        </ng-template>

        <nz-autocomplete
          #auto
          nzBackfill
          (selectionChange)="onSelect($event)"
          [nzOverlayStyle]="{ minWidth: '300px' }"
        >
          @if (!searchText) {
            <span style="padding: 6px 6px !important" nz-typography nzType="secondary">
              <i nz-icon nzType="history"></i> Last Visited
            </span>
          }

          <nz-auto-option *ngFor="let menu of menus" [nzValue]="menu" [nzLabel]="menu.name">
            <nz-row>
              <nz-col nzFlex="auto">
                <i nz-icon [nzType]="menu.iconClass || 'right-circle'"></i>
                <span class="ml-5">{{ menu.name }}</span>
              </nz-col>
              <nz-col>
                <i
                  class="show-on-hover app-link fa fa-external-link"
                  (click)="onSelectNewWin($event, menu)"
                ></i>
              </nz-col>
            </nz-row>
          </nz-auto-option>
        </nz-autocomplete>

        <ng-keyboard-shortcuts [shortcuts]="shortcuts"></ng-keyboard-shortcuts>
      </nz-space>
    </nz-col>

    <!-- RIGHT SECTION -->
    <nz-col>
      <nz-space nzAlign="center" nzSize="small">
        <!-- Directory -->
        @if (enableMobile) {
          <a
            nz-button
            nzType="link"
            href="https://focalshipping24.sharepoint.com"
            target="_blank"
            nz-tooltip
            nzTooltipTitle="Focal Directory"
          >
            <i nz-icon nzType="contacts"></i>
          </a>

          <nz-divider nzType="vertical"></nz-divider>

          <!-- Mobile -->
          <a
            nz-button
            nzType="link"
            (click)="mobileAppInfo()"
            nz-tooltip
            nzTooltipTitle="Mobile Application"
          >
            <i nz-icon nzType="mobile"></i>
            <span class="circle-indicator pulse"></span>
          </a>
        }

        <nz-divider nzType="vertical"></nz-divider>

        <!-- Support -->
        <a
          nz-button
          nzType="link"
          href="mailto:support@speehive.com"
          nz-tooltip
          nzTooltipTitle="Support"
        >
          <i nz-icon nzType="customer-service"></i>
        </a>

        <nz-divider nzType="vertical"></nz-divider>

        <a
          nz-button
          nzType="link"
          (click)="openNotificationsDrawer()"
          nz-tooltip
          nzTooltipTitle="Notifications"
        >
          <i class="trigger" nz-icon nzType="bell" nzTheme="twotone"></i>
          @if (allAlertsForCurrentUser.length > 0) {
            <div class="circle-indicator pulse"></div>
          }
        </a>

        <nz-divider nzType="vertical"></nz-divider>

        <!-- Profile -->
        <a (click)="profileClick()">
          @if (currentUser) {
            <ng-container>
              <nz-avatar nzSize="small" [nzText]="$safeNavigationMigration(currentUser?.userName?.charAt(0))"></nz-avatar>
              <span style="margin-left: 6px; color: black;">{{ currentUser?.userName }}</span>
            </ng-container>
          }
        </a>
      </nz-space>
    </nz-col>
  </nz-row>
</nz-header>

<ng-template #menuDrawerTitle>
  <div class="drawer-header">
    <span class="drawer-title">Menu</span>

    <button nz-button nzType="text" nzShape="circle" (click)="menuDrawerRef?.close()">
      <i nz-icon nzType="close"></i>
    </button>
  </div>
</ng-template>

<div class="version">{{ currentApplicationVersion }}</div>

<nz-modal
  [(nzVisible)]="isMobileAppInfoVisible"
  nzCentered
  nzTitle="Mobile"
  [nzFooter]="null"
  (nzOnCancel)="isMobileAppInfoVisible = false"
  nzWidth="680px"
>
  <div *nzModalContent class="header" style="margin-bottom: 10px">
    <b>Get the Mobile App</b><br />
    <br />
    <a
      href="https://apps.apple.com/ae/app/focal-shipping/id1599927519"
      target="_blank"
      class="store__button store__button--apple"
      role="img"
      aria-label="Get Spendee on App Store"
      data-track-click='{"category":"Exit to Store","action":"Exit","label":"store:Apple, location:Homepage Top"}'
      ><img
        style="
          display: inline-block;
          overflow: hidden;
          border-radius: 13px;
          width: 310px;
          height: 110px;
        "
        src="https://focalshipping.com/wp-content/uploads/2024/07/App-Store-Button.png"
      />
    </a>
    <a
      href="https://play.google.com/store/apps/details?id=com.foculshipping.foculshippingwaz&amp;hl=en&amp;gl=US&amp;pli=1"
      class="store__button store__button--google"
      target="_blank"
      role="img"
      aria-label="Get Spendee on Play Store"
      data-track-click='{"category":"Exit to Store","action":"Exit","label":"store:Google, location:Homepage Top"}'
    >
      <img
        style="
          display: inline-block;
          overflow: hidden;
          border-radius: 13px;
          width: 310px;
          height: 110px;
          margin-left: 25px;
        "
        src="https://focalshipping.com/wp-content/uploads/2024/07/Google-Play-Button.png"
        alt=""
      />
    </a>
  </div>
</nz-modal>

<nz-drawer
  [nzVisible]="isNotificationDrawerVisible"
  nzTitle="Notifications"
  [nzWidth]="'30%'"
  [nzClosable]="true"
  (nzOnClose)="closeNotifications()"
  [nzFooter]="notificationfooterTemplate"
>
  <div *nzDrawerContent class="alert-log-container">
    @if (allAlertsForCurrentUser.length === 0) {
      <nz-empty
        nzNotFoundImage="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
        nzNotFoundContent="No Notifications"
      ></nz-empty>
    } @else {
      <div class="alert-item" *ngFor="let alert of latestAlertsForDrawer">
        <div class="alert-header">
          <span class="alert-time">{{ alert.scheduledAt | date: 'dd MMM yyyy, hh:mm a' }}</span>
          <!-- <i
          nz-icon
          nzType="close"
          nzTheme="outline"
          class="alert-close"
          (click)="removeAlert(alert)"
        ></i> -->
        </div>

        <div class="alert-body">
          <i nz-icon nzType="info-circle" nzTheme="fill" class="alert-icon"></i>
          <a class="alert-link" href="javascript:void(0)">{{ alert.projectCode }}</a>
          <span class="alert-message">- {{ alert.message }}</span>
        </div>
      </div>
    }
  </div>
</nz-drawer>

<ng-template #notificationfooterTemplate>
  <div class="notification-footer">
    <!-- <button
      nz-button
      nzType="default"
      nz-size="small"
      (click)="markAllAsRead()"
      [disabled]="allAlertsForCurrentUser.length === 0"
    >
      Mark all as read
    </button> -->
    <span (click)="goToAllNotifications()"
      >View all notifications <i nz-icon nzType="double-right"></i
    ></span>
  </div>
</ng-template>
